/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { doLogout } from "../../../actions/auth";
import { searchAction } from "../../../actions/home";
import Approve from "../../../assets/svg/approve";
import Basket from "../../../assets/svg/basket";
import Cancle from "../../../assets/svg/cancle";
import Search from "../../../assets/svg/search";
import SmallSearch from "../../../assets/svg/smallSearch";
import { WORDPRESS_BASE } from "../../../constants/api";
import { SEARCH_ITEM_F } from "../../../constants/types";
import { useDetectOutsideClick } from "../../../Hooks/useDetectOutsideClick";
import { toAbsoluteUrl } from "../../../utils";
import "./newHeader.scss";

const NewHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mediaURL } = useSelector((state) => state.metaReducer);

  const { searchItemsList } = useSelector((state) => state.home);
  const basketCount = useSelector((state) => state.metaReducer?.basketCount);
  const { notificationCount } = useSelector((state) => state.metaReducer);

  const { userDetails } = useSelector((state) => state.user);
  const user = JSON.parse(localStorage.getItem("webUser"));
  const userId = JSON.parse(localStorage.getItem("webUser"))?.data?._id;
  const profilePic = JSON.parse(localStorage.getItem("profilePic"));
  // const userName = JSON.parse(localStorage.getItem("userName"));

  const headerRef = useRef(null);
  const searchRef = useRef(null);
  const modalRef = useRef(null);

  const [searchIsOpen, setSearchIsOpen] = useState(false);
  const [isSearchbarShow, setIsSearchbarShow] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [searchItems, setSearchItems] = useState([]);
  const [searchTexts, setSearchTexts] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const itms = searchItemsList?.map((itm) => {
      if (itm.type === "Nonprofit") {
        return {
          ...itm,
          name: `${itm.name} ${itm?.taxId ? itm?.taxId : ""}`,
          updatedName: (
            <div className="searchItm">
              <div>{`${itm.name} (Nonprofit)`}</div>{" "}
              {itm.isNavigator === false && (
                <figure className="charityRight">
                  <Approve />
                </figure>
              )}
            </div>
          ),
        };
      }
      return {
        ...itm,
        name: `${itm.name} (Cause/Affiliation)`,
        updatedName: <div>{`${itm.name} (Cause/Affiliation)`}</div>,
      };
    });
    setSearchItems(itms);
  }, [searchItemsList]);

  useEffect(() => {
    if (!isSearching || searchTexts?.length < 2) {
      dispatch({
        type: SEARCH_ITEM_F,
      });
      setShowDropdown(false);
      return;
    }

    const fetchResults = () => {
      setLoading(true);
      setShowDropdown(true);
      dispatch(
        searchAction({
          search: searchTexts.replace("-", ""),
          isNavigator: true,
        })
      ).finally(() => {
        setLoading(false);
      });
    };

    const debounceTimer = setTimeout(fetchResults, 400); // Debounce API call

    return () => clearTimeout(debounceTimer);
  }, [searchTexts, isSearching]);

  const dropdownOpen = () => {
    setIsMoreOpen(!isMoreOpen);
  };

  const handleToggle = () => {
    setIsActive((prev) => !prev);
  };

  useDetectOutsideClick(modalRef, () => {
    setIsMoreOpen(false);
  });

  useDetectOutsideClick(searchRef, () => {
    setSearchIsOpen(false);
    // dispatch({
    //   type: SEARCH_ITEM_F,
    // });
  });

  useDetectOutsideClick(headerRef, () => {
    setIsActive(false);
  });

  const handleOnSelect = (item) => {
    if (item.type === "Nonprofit") navigate(`/charity_details/${item.id}`);
    else navigate(`/cause_details/${item.id}`);
  };

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    setSearchTexts(string.replace(/[^\w]/g, ""));
  };

  // const onChangeFun = (e) => {
  //   if (e.length >= 3 || e.length === 0) setSearchTexts(e);
  // };

  // const optimizedFn = debounce(onChangeFun);

  const handleInputChange = (e) => {
    setSearchTexts(e.target.value);
    setIsSearching(true);
  };

  const logoutHandler = () => {
    dispatch(doLogout()).then((res) => {
      toast.success(res?.message);
      navigate("/signin");
      window.location.reload();
    });
  };

  const searchItemClickHandler = (item) => {
    handleOnSelect(item);
    setSearchTexts(item.name);
    setShowDropdown(false);
    setIsSearching(false);
  };

  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: "block", textAlign: "left" }}>
          {item.updatedName}
        </span>
      </>
    );
  };

  const renderSearchItems = () => {
    if (loading) {
      return (
        <li className="result">
          <SmallSearch />
          <div className="item-name">Searching...</div>
        </li>
      );
    }
    if (searchItems?.length > 0) {
      return searchItems?.map((item) => (
        <li
          className="result"
          key={item.id}
          onClick={() => {
            searchItemClickHandler(item);
          }}
        >
          <SmallSearch />
          <div className="item-name">{item.updatedName}</div>
        </li>
      ));
    } else {
      return (
        <li className="result">
          <SmallSearch />
          <div className="item-name">No result found</div>
        </li>
      );
    }
  };

  return (
    <header className="header">
      <div ref={headerRef} className="container full-container">
        <div className="header-wrap d-flex justify-content-between ">
          <div className="logo">
            <Link to="/">
              {/* <img src={toAbsoluteUrl("/images/logo.svg")} alt="logo" /> */}
              <img
                src={toAbsoluteUrl("/images/without_tagline_logo.svg")}
                alt="logo"
              />
            </Link>
          </div>
          <div className="nav d-flex align-items-center justify-content-between">
            <div className="navigation d-flex">
              <ul className={`header-menu ${!isActive ? "" : "open-menu"} `}>
                <li>
                  <a activeclassname="active" href={WORDPRESS_BASE + "/about/"}>
                    About <br /> Rosi
                  </a>
                </li>
                {/* <li>
                  <Link
                    className="dropdownLink"
                    to={"/about"}
                    exact="true"
                    activeclassname="active"
                  >
                    About <br /> Rosi
                  </Link>
                </li> */}
                <li>
                  <Link
                    className="dropdownLink"
                    to={"/charity"}
                    exact="true"
                    activeclassname="active"
                  >
                    Search <br /> Nonprofits
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdownLink"
                    to={"/cause"}
                    exact="true"
                    activeclassname="active"
                  >
                    Causes/ <br /> Affiliations
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdownLink"
                    to={"/community/1"}
                    exact="true"
                    activeclassname="active"
                  >
                    Join <br /> Communities
                  </Link>
                </li>
                {userDetails?.userType !== 2 && (
                  <li>
                    <Link
                      className="dropdownLink"
                      to={"/giving_partner"}
                      exact="true"
                      activeclassname="active"
                    >
                      Giving <br /> Partners
                    </Link>
                  </li>
                )}
                <li>
                  <Link
                    className="dropdownLink"
                    to={"/post"}
                    exact="true"
                    activeclassname="active"
                  >
                    Feed
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdownLink"
                    to={"/chat"}
                    exact="true"
                    activeclassname="active"
                  >
                    Chat
                  </Link>
                </li>
                {userDetails?.userType === 2 && (
                  <li>
                    <Link
                      className="dropdownLink"
                      to={"/Giving_Partner_Details"}
                      exact="true"
                      activeclassname="active"
                    >
                      My Giving <br /> Partner
                    </Link>
                  </li>
                )}
                <li>
                  <span className="headerDropdown" onClick={dropdownOpen}>
                    <span className="dropdownLink">More</span>
                    <span className={!isMoreOpen ? "moreAnimation" : "more"}>
                      <img
                        src={toAbsoluteUrl("/images/dropdown.svg")}
                        alt="dropdown"
                      />
                    </span>
                    {isMoreOpen && (
                      //onclick close beacuse not  log in user are not use
                      <ul className="dropdown" ref={modalRef}>
                        <li>
                          <a
                            activeclassname="active"
                            href={WORDPRESS_BASE + "/"}
                          >
                            Home
                          </a>
                        </li>
                        {/* <li>
                          <a
                            activeclassname="active"
                            href={WORDPRESS_BASE + "/about/"}
                          >
                            About <br /> Us
                          </a>
                        </li> */}
                        <li>
                          <a
                            activeclassname="active"
                            href={WORDPRESS_BASE + "/contact-us/"}
                          >
                            Support / Contact Rosi
                          </a>
                        </li>
                        <li>
                          <NavLink activeclassname="active" to="/faq">
                            FAQs
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </span>
                </li>
                {/* <li onClick={() => setIsActive(false)}>
                  <a activeclassname="active" href={WORDPRESS_BASE + "/"}>
                    Home
                  </a>
                </li>

                <li>
                  <span className="headerDropdown">
                    <Link
                      className="dropdownLink"
                      to={"/about"}
                      exact="true"
                      activeclassname="active"
                    >
                      About
                    </Link>
                    <span className={"more"}>
                      <img
                        src={toAbsoluteUrl("/images/dropdown.svg")}
                        alt="dropdown"
                      />
                    </span>
                    <ul className="dropdown">
                      <li>
                        <a
                          href={WORDPRESS_BASE + "/founder/"}
                          activeclassname="active"
                        >
                          Founder’s Journey
                        </a>
                      </li>
                    </ul>
                  </span>
                </li>

                <li onClick={() => setIsActive(false)}>
                  <a
                    activeclassname="active"
                    href={WORDPRESS_BASE + "/rosi-givers/"}
                  >
                    Rosi Givers
                  </a>
                </li>

                <li>
                  <span className="headerDropdown">
                    <a
                      className="dropdownLink"
                      activeclassname="active"
                      href={WORDPRESS_BASE + "/nonprofits/"}
                    >
                      Nonprofits
                    </a>

                    <span className={"more"}>
                      <img
                        src={toAbsoluteUrl("/images/dropdown.svg")}
                        alt="dropdown"
                      />
                    </span>
                    <ul className="dropdown">
                      <li>
                        <a
                          activeclassname="active"
                          href={WORDPRESS_BASE + "/causes-overview/"}
                        >
                          Causes/Affiliations
                        </a>
                      </li>
                      <li>
                        <a
                          activeclassname="active"
                          href={WORDPRESS_BASE + "/communities/"}
                        >
                          Communities
                        </a>
                      </li>
                      <li>
                        <a
                          activeclassname="active"
                          href={WORDPRESS_BASE + "/events/"}
                        >
                          Events
                        </a>
                      </li>
                    </ul>
                  </span>
                </li>

                <li onClick={() => setIsActive(false)}>
                  <a
                    activeclassname="active"
                    href={WORDPRESS_BASE + "/partners/"}
                  >
                    Giving Partners
                  </a>
                </li>

                {user?.data?.authToken && (
                  <li onClick={() => setIsActive(false)}>
                    <NavLink exact="true" activeclassname="active" to="/post">
                      Chat & Feed
                    </NavLink>
                  </li>
                )}

                {userDetails?.userType === 2 && (
                  <li onClick={() => setIsActive(false)}>
                    <NavLink to="/Giving_Partner_Details">Partners</NavLink>
                  </li>
                )}

                <li>
                  <span className="headerDropdown">
                    <a
                      className="dropdownLink"
                      activeclassname="active"
                      href={WORDPRESS_BASE + "/support/"}
                    >
                      Support
                    </a>
                    <span className={"more"}>
                      <img
                        src={toAbsoluteUrl("/images/dropdown.svg")}
                        alt="dropdown"
                      />
                    </span>
                    <ul className="dropdown">
                      <li>
                        <a
                          activeclassname="active"
                          href={WORDPRESS_BASE + "/contact-us/"}
                        >
                          Contact Us
                        </a>
                      </li>
                    </ul>
                  </span>
                </li>

                <li className="registerItem">
                  <Link to="/registration" onClick={handleToggle}>
                    Sign Up
                  </Link>
                </li> */}
              </ul>
              <div
                className={`toggle-area ${!isActive ? "" : "close-btn1"}`}
                onClick={handleToggle}
              >
                <ul className="toggle">
                  <li className="top"></li>
                  <li className="middle"></li>
                  <li className="bottom"></li>
                </ul>
              </div>
            </div>
            <div className="navigation-right">
              {/* with out login */}
              {!userId || user?.data?.userType === 3 ? (
                <ul className="withoutLoginList">
                  <li className="logOutSearch search">
                    <div
                      ref={searchRef}
                      className={searchIsOpen ? "autoSearch" : "searchInput"}
                    >
                      {/* <ReactSearchAutocomplete
                        items={searchItems}
                        onSelect={handleOnSelect}
                        onSearch={handleOnSearch}
                        autoFocus={true}
                        formatResult={formatResult}
                        className="headerSearch"
                        placeholder="Search Nonprofit/Tax ID & Causes/Affiliations "
                      /> */}
                      <div className="my-wrapper">
                        <div className="search-field">
                          {/* <span className="search-icon"> */}
                          <SmallSearch />
                          {/* </span> */}
                          <input
                            type="text"
                            placeholder="Search Nonprofit/Tax ID & Causes/Affiliations "
                            value={searchTexts}
                            // ref={searchRef}
                            onChange={(e) => handleInputChange(e)}
                          />
                          {searchTexts && (
                            <span
                              className="cancle-search"
                              onClick={() => {
                                setSearchTexts("");
                              }}
                            >
                              <Cancle />
                            </span>
                          )}
                        </div>
                        {/* {searchItems?.length || searchTexts?.length > 2 ? ( */}
                        {showDropdown ? (
                          <div>
                            <div className="line"></div>
                            <ul>{renderSearchItems()}</ul>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                    <a
                      href="true"
                      className="demo"
                      onClick={(e) => {
                        e.preventDefault();
                        setSearchIsOpen((prev) => !prev);
                        setIsSearchbarShow(true);
                      }}
                    >
                      <Search />
                    </a>
                  </li>
                  {user?.data?.userType === 3 ? (
                    <li>
                      <span className="guestName">
                        {`Hello Guest, ${user?.data?.firstName} ${user?.data?.lastName}`}
                      </span>
                    </li>
                  ) : (
                    <li>
                      <Link to="/registration" className="register">
                        Sign Up
                      </Link>
                    </li>
                  )}
                  <li>
                    {userId && (
                      <Link
                        className="basketCount"
                        to={
                          userId || user?.data?.userType !== 3
                            ? "/basket"
                            : "/charity"
                        }
                      >
                        <Basket />
                        {!basketCount ? "" : <span>{basketCount}</span>}
                      </Link>
                    )}
                  </li>
                </ul>
              ) : (
                <ul className="logginList">
                  <li className="loginSearch search">
                    {isSearchbarShow && (
                      <div
                        ref={searchRef}
                        className={searchIsOpen ? "autoSearch" : "searchInput"}
                      >
                        {/* <ReactSearchAutocomplete
                          items={searchItems}
                          onSelect={handleOnSelect}
                          onSearch={handleOnSearch}
                          autoFocus
                          formatResult={formatResult}
                          className="headerSearch"
                          placeholder="Search Nonprofit/Tax ID & Causes/Affiliations "
                        /> */}
                        <div className="my-wrapper">
                          <div className="search-field">
                            {/* <span className="search-icon"> */}
                            <SmallSearch />
                            {/* </span> */}
                            <input
                              type="text"
                              placeholder="Search Nonprofit/Tax ID & Causes/Affiliations "
                              value={searchTexts}
                              // ref={searchRef}
                              onChange={(e) => handleInputChange(e)}
                            />
                            {searchTexts && (
                              <span
                                className="cancle-search"
                                onClick={() => {
                                  setSearchTexts("");
                                }}
                              >
                                <Cancle />
                              </span>
                            )}
                          </div>
                          {/* {searchItems?.length || searchTexts?.length > 2 ? ( */}
                          {showDropdown ? (
                            <div>
                              <div className="line"></div>
                              <ul>{renderSearchItems()}</ul>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    )}
                    <a
                      href="true"
                      className="demo"
                      to=""
                      onClick={(e) => {
                        e.preventDefault();
                        setSearchIsOpen((prev) => !prev);
                        setIsSearchbarShow(true);
                      }}
                    >
                      <Search />
                    </a>
                  </li>
                  {/* <li>
                    <Link to="/chat">
                      <div className="message">
                        <img
                          src={toAbsoluteUrl("/images/message.svg")}
                          alt="message"
                        />
                      </div>
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/notification">
                      <div className="bell">
                        <img
                          src={toAbsoluteUrl("/images/bell.svg")}
                          alt="bell"
                        />
                        {!notificationCount ? "" : <span></span>}
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/profile_details"
                      state={{ userID: user?.data?._id }}
                      className="userHeader"
                    >
                      <figure className="userProfile">
                        {profilePic === "null" || mediaURL === undefined ? (
                          <img
                            src={toAbsoluteUrl("/images/placeholder.png")}
                            alt="placeholder"
                          />
                        ) : (
                          <img
                            src={`${mediaURL}userProfilePic/${profilePic}`}
                            alt="user"
                          // onError="this.src='fallback-img.jpg'"
                          />
                        )}
                      </figure>
                      {/* <h4>{userName}</h4> */}
                    </Link>
                  </li>
                  {/* <li>
                    <button className="exitBtn" onClick={logoutHandler}>
                      <img
                        src={toAbsoluteUrl("/images/exit.png")}
                        alt="logout"
                      />
                    </button>
                  </li> */}
                  <li>
                    {userId && (
                      <Link
                        className="basketCount"
                        to={userId ? "/basket" : "/charity"}
                      >
                        <Basket />
                        {basketCount ? <span>{basketCount}</span> : ""}
                      </Link>
                    )}
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default NewHeader;
